import { titles } from '@/mocks/titles';
import TitleCard from '@/components/feature/TitleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import LatestUpdates from '@/pages/home/components/LatestUpdates';

const featured = [...titles].sort((a, b) => b.rating - a.rating).slice(0, 8);

export default function Home() {
  return (
    <div className="w-full pb-4">
      <HeroCarousel />

      <section className="w-full px-4 md:px-8 pt-8 md:pt-10">
        <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          秋霞电影网 · 最新电影电视剧在线观看平台
        </h1>
        <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          聚合海量电影与电视剧资源，分类清晰、更新及时。无论你是追剧党还是电影爱好者，都能在这里快速找到想看的内容。
        </p>
      </section>

      <CategoryEntry />

      <section className="w-full px-4 md:px-8 pb-10">
        <SectionHeading title="今日推荐" subtitle="精选高分影视，值得一看" moreTo="/list" />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {featured.map((item) => (
            <TitleCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-10">
        <div className="rounded-xl bg-background-100 border border-background-200 px-4 md:px-6 py-6 md:py-8">
          <SectionHeading title="最新更新" subtitle="已上线影视资源，持续更新中" moreTo="/category/tv" moreLabel="去看剧集" />
          <LatestUpdates />
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-2 rounded-xl bg-primary-950 px-6 md:px-8 py-8 md:py-10 text-background-100">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">关于秋霞电影网</h2>
            <p className="text-sm md:text-base leading-relaxed text-background-200">
              秋霞电影网定位为面向广大影视爱好者的内容门户，专注提供电影与电视剧资源的分类浏览、精准筛选与便捷检索体验。
              我们持续跟踪影视更新动态，让最新、最热的作品第一时间呈现在你眼前。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 rounded-md bg-background-50/10 px-3 py-2 text-sm">
                <i className="ri-database-2-line text-accent-400"></i>资源分类浏览
              </span>
              <span className="inline-flex items-center gap-2 rounded-md bg-background-50/10 px-3 py-2 text-sm">
                <i className="ri-filter-3-line text-accent-400"></i>多维筛选排序
              </span>
              <span className="inline-flex items-center gap-2 rounded-md bg-background-50/10 px-3 py-2 text-sm">
                <i className="ri-bookmark-line text-accent-400"></i>本地收藏追剧
              </span>
            </div>
          </div>

          <div className="rounded-xl bg-accent-100 border border-accent-300 px-6 py-8 md:py-10">
            <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950 text-2xl mb-4">
              <i className="ri-movie-2-line"></i>
            </span>
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2">内容更新策略</h3>
            <p className="text-sm text-foreground-700 leading-relaxed">
              电影与电视剧资源每日巡检更新，热门剧集连载进度实时同步，新上线作品优先展示于首页焦点与最新更新板块。
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}